var _rect, _rect2, _rect3, _path, _path2, _line, _line2, _line3, _line4, _path3, _line5, _line6, _path4, _path5, _path6, _path7, _rect4, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspectionLists(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 4.84082,
    width: 21.9909,
    height: 29.4091,
    rx: 1.25,
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.94531,
    y: 2.85449,
    width: 13.6,
    height: 3.70909,
    fill: "#4E4E4E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.93164,
    y: 3.60449,
    width: 9.62727,
    height: 2.20909,
    rx: 1.10455,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7452 1C10.2616 1 10.3028 2.64848 10.5088 3.47273H12.9815C13.1876 2.64848 13.2288 1 11.7452 1Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70898 11.8179L4.94535 12.7452L7.41808 10.2725",
    stroke: "#A3A3A3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 11.0088,
    x2: 19.7816,
    y2: 11.0088,
    stroke: "#A3A3A3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 13.4814,
    x2: 19.7816,
    y2: 13.4814,
    stroke: "#A3A3A3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 18.4272,
    x2: 19.7816,
    y2: 18.4272,
    stroke: "#A3A3A3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 20.8999,
    x2: 19.7816,
    y2: 20.8999,
    stroke: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70898 26.6548L4.94535 27.5821L7.41808 25.1094",
    stroke: "#A3A3A3"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 25.8457,
    x2: 19.7816,
    y2: 25.8457,
    stroke: "#A3A3A3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 28.3184,
    x2: 19.7816,
    y2: 28.3184,
    stroke: "#A3A3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00054 18.3599L7.00038 21.3599",
    stroke: "#A3A3A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.3599L6.99994 18.3599",
    stroke: "#A3A3A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5321 14.3606C27.301 13.4459 28.6658 13.3278 29.5804 14.0966C30.4951 14.8655 30.6133 16.2303 29.8444 17.145L25.9549 21.7719L22.6426 18.9875L26.5321 14.3606Z",
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9168 30.7448C17.7511 30.9418 17.5447 31.1007 17.3118 31.2104C15.9344 31.8593 14.4298 30.5946 14.8323 29.1261C14.9004 28.8778 15.0214 28.6472 15.1871 28.4501L16.3665 27.0471L19.0962 29.3417L17.9168 30.7448Z",
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2895,
    y: 19.997,
    width: 3.56608,
    height: 8.9164,
    transform: "rotate(40.051 22.2895 19.997)",
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3164 31.064L14.4049 32.1484",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2825 16.8093C30.6075 16.6198 30.8548 16.365 31.3208 16.7568C31.7868 17.1485 31.4924 17.7353 31.2197 18.0598C30.7639 18.602 29.789 19.1704 28.8774 20.2548C28.2697 20.9777 27.3987 22.2504 27.8647 22.6422C28.3308 23.0339 28.7511 22.7704 28.903 22.5897",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionLists);
export default __webpack_public_path__ + "static/media/inspection-lists.632bfb160b18de53d2cc9d4d4da53f69.svg";
export { ForwardRef as ReactComponent };